import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { esignFlowsActions } from 'features/esignFlows';

const useEsignFlows = () => {
  const dispatch = useDispatch();
  const getEsignFlow = useCallback(() => dispatch(esignFlowsActions.getEsignFlow()), [dispatch]);
  const createEsignFlow = useCallback(esign_flow => dispatch(esignFlowsActions.createEsignFlow(esign_flow)), [dispatch]);
  const updateEsignFlow = useCallback(esign_flow => dispatch(esignFlowsActions.updateEsignFlow(esign_flow)), [dispatch]);
  const deleteEsignFlow = useCallback(() => dispatch(esignFlowsActions.deleteEsignFlow()), [dispatch]);
  const clearLocalActiveEsignFlow = useCallback(() => dispatch(esignFlowsActions.clearLocalActiveEsignFlow()), [dispatch]);

  return {
    getEsignFlow,
    createEsignFlow,
    updateEsignFlow,
    deleteEsignFlow,
    clearLocalActiveEsignFlow
  };
};

export default useEsignFlows;